<template>
  <section>
    <div class="tip" style="margin:0 0 0 20px">* 项目基本资料</div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目编号">
          <el-input size="small" :disabled="true" placeholder="请输入项目编号" v-model="project.number"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="项目需求单位">
      <el-input size="small" :disabled="true" v-model="project.deptName"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目负责人">
          <el-input size="small" :disabled="true" v-model="project.leader.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系方式">
          <el-input size="small" :disabled="true" v-model="project.leader.mobile"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目名称">
          <el-input size="small" v-model="project.name" :disabled="true" placeholder="请输入项目名称"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="立项批文号">
          <el-input size="small" v-model="form.lxpwh" placeholder="请输入立项批文号"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <el-form-item label="项目介绍">
      <el-input type="textarea" placeholder="请输入项目相关情况介绍" :autosize="{ minRows: 3, maxRows: 6}" size="small" v-model="form.intro"></el-input>
    </el-form-item>
  </section>
</template>

<script>
  export default {
    props: ['project', 'formByFather', 'userData'],
    data() {
      return {
        form: {},
      }
    },
    mounted() {
      this.form = this.formByFather

      // this.form.depId = this.userData.secDepIds.split(",")[0]
      // this.form.leaderId = this.userData.id
    },
    methods: {
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/createSetup.vue